module.exports = __webpack_public_path__ + "static/media/icon-radio-white-flag.a8e9a1cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-radio-white-flag.svg
// module id = 2899
// module chunks = 0